/* eslint-disable import/prefer-default-export */
const pluralRules = new Intl.PluralRules('en-US')

export function pluralize(count, singular, plural, connector = ' ') {
  const grammaticalNumber = pluralRules.select(count)

  switch (grammaticalNumber) {
    case 'one':
      return count + connector + singular
    case 'other':
      return count + connector + plural
    default:
      return count + connector + singular
  }
}
